// extracted by mini-css-extract-plugin
export default {"Content":"ContentTable_Content__tDXmj"};